import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext.jsx';
import Navbar from './components/Navbar.jsx';
import Breadcrumbs from './components/Breadcrumbs.jsx';
import Login from './pages/Login.jsx';
import Dashboard from './pages/Dashboard.jsx';
import MarketingDashboard from './pages/MarketingDashboard.jsx';
import Contacts from './pages/Contacts.jsx';
import Templates from './pages/Templates.jsx';
import TemplateImages from './pages/TemplateImages.jsx';
import Campaigns from './pages/Campaigns.jsx';
import CampaignDetail from './pages/CampaignDetail.jsx';
import Events from './pages/Events.jsx';
import EventDetail from './pages/EventDetail.jsx';
import Registrations from './pages/Registrations.jsx';
import EventRsvp from './pages/EventRsvp.jsx';
import RateCalculator from './pages/RateCalculator.jsx';
import RateClients from './pages/RateClients.jsx';
import News from './pages/News.jsx';
import Careers from './pages/Careers.jsx';
import TeamMembers from './pages/TeamMembers.jsx';
import Signature from './pages/Signature.jsx';
import VideoBackgrounds from './pages/VideoBackgrounds.jsx';
import NCFs from './pages/NCFs.jsx';
import NcfDetail from './pages/NcfDetail.jsx';
import Billing from './pages/Billing.jsx';
import PrivateRoute from './components/PrivateRoute.jsx';
import Admin from './pages/Admin.jsx';
import PolicyReviewRun from './pages/PolicyReviewRun.jsx';
import AlertModalProvider from './components/AlertModalProvider.jsx';

const AppLayout = () => {
  const location = useLocation();
  const isRsvpRoute = location.pathname.startsWith('/events/rsvp/');

  return (
    <div className="App">
      {!isRsvpRoute && <Navbar />}
      {!isRsvpRoute && <Breadcrumbs />}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<Login />} />
        <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/marketing-dashboard" element={<PrivateRoute><MarketingDashboard /></PrivateRoute>} />
        <Route path="/events/rsvp/:token" element={<EventRsvp />} />
        <Route path="/contacts" element={<PrivateRoute><Contacts /></PrivateRoute>} />
        <Route path="/templates" element={<PrivateRoute requiredTab="templates"><Templates /></PrivateRoute>} />
        <Route path="/template-images" element={<PrivateRoute requiredTab="template-images"><TemplateImages /></PrivateRoute>} />
        <Route path="/campaigns" element={<PrivateRoute><Campaigns /></PrivateRoute>} />
        <Route path="/campaigns/:id" element={<PrivateRoute><CampaignDetail /></PrivateRoute>} />
        <Route path="/events" element={<PrivateRoute><Events /></PrivateRoute>} />
        <Route path="/events/:id" element={<PrivateRoute><EventDetail /></PrivateRoute>} />
        <Route path="/registrations" element={<PrivateRoute><Registrations /></PrivateRoute>} />
        <Route path="/rate-calculator" element={<PrivateRoute><RateCalculator /></PrivateRoute>} />
        <Route path="/rate-calculator/clients" element={<PrivateRoute><RateClients /></PrivateRoute>} />
        <Route path="/ncfs" element={<PrivateRoute><NCFs /></PrivateRoute>} />
        <Route path="/ncfs/:id" element={<PrivateRoute><NcfDetail /></PrivateRoute>} />
        <Route path="/billing" element={<PrivateRoute><Billing /></PrivateRoute>} />
        <Route path="/news" element={<PrivateRoute><News /></PrivateRoute>} />
        <Route path="/careers" element={<PrivateRoute><Careers /></PrivateRoute>} />
        <Route path="/team-members" element={<PrivateRoute><TeamMembers /></PrivateRoute>} />
        <Route path="/signature-builder" element={<PrivateRoute><Signature /></PrivateRoute>} />
        <Route path="/video-backgrounds" element={<PrivateRoute><VideoBackgrounds /></PrivateRoute>} />
        <Route path="/admin" element={<PrivateRoute><Admin /></PrivateRoute>} />
        <Route path="/admin/policy-review/:runId" element={<PrivateRoute><PolicyReviewRun /></PrivateRoute>} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <AlertModalProvider>
        <Router>
          <AppLayout />
        </Router>
      </AlertModalProvider>
    </AuthProvider>
  );
}

export default App;
